import styled from 'styled-components'

export const ContainerAlerta = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
`
